import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeAssistant: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"code-assistant, vibe-coding"} maskId="square-outlined-radius-0-stroke-1-IconCodeAssistant"><path d="M13 3.5H3.5V20.5H20.5V11" stroke="currentColor"/><path d="M10.75 8.75L7.5 12L10.75 15.25" stroke="currentColor"/><path d="M13.25 8.75L16.5 12L13.25 15.25" stroke="currentColor"/><path d="M19 1L20.0804 3.91964L23 5L20.0804 6.08036L19 9L17.9196 6.08036L15 5L17.9196 3.91964L19 1Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCodeAssistant;
